<template>
    <nav class="scroll-navigation">
        <BaseDotLink
            v-for="item in populatedItems"
            :key="item.href"
            :active="item.isActive"
            class="scroll-navigation__link"
        >
            <a :href="item.href">
                {{ item.label }}
            </a>
        </BaseDotLink>
    </nav>
</template>

<script setup>
import { kebabCase } from 'lodash-es';
import { useIntersectionObserver } from '@vueuse/core';

const { t } = useI18n();

const props = defineProps({
    pending: {
        type: Boolean,
        default: false,
        required: false
    },
    entry: {
        type: Object,
        required: false,
        default: undefined
    },
    items: {
        type: Array,
        required: false,
        default: () => {
            return [
                {
                    entryField: 'apartmentsBlock',
                    label: 'apartments',
                    id: null
                },
                {
                    entryField: 'carousselBlock',
                    label: 'facilities',
                    id: null
                },
                {
                    entryField: 'relatedItems',
                    label: 'stories',
                    id: null
                },
                {
                    entryField: 'storytellingBlock',
                    label: 'neighbourhood',
                    id: null
                },
                {
                    entryField: 'promoBlock',
                    label: 'meeting-events',
                    id: null
                },
                {
                    entryField: 'textImage',
                    label: 'contact',
                    id: null
                },
            ];
        }
    },
});

const populatedItems = ref([]);

watchEffect(() => {
    populatedItems.value = props.items.map(item => {
        // Find the item in the entry by its entryField and set it's "title" as the label
        const blockTitle = props.entry?.[item.entryField]?.[0]?.title || props.entry?.[item.entryField]?.[0]?.blockTitle;

        if (blockTitle?.length || item.id) {
            let id;

            if (item.id) {
                id = item.id;
            } else {
                id = kebabCase(blockTitle);
            }

            return {
                label: t(item.label),
                href: `#${id}`,
                isActive: false
            };
        }
    })?.filter(item => item !== undefined);
});

onMounted(() => {
    populatedItems?.value?.forEach(item => {
        useIntersectionObserver(
            document.querySelector(item.href),
            ([{ isIntersecting }]) => {
                item.isActive = isIntersecting;
            },
            { threshold: .5 }
        );
    });
});
</script>

<style lang="less">
.scroll-navigation {
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-sm) var(--spacing-md);
    gap: var(--spacing-md);

    position: sticky;
    z-index: 50;
    top: var(--navbar-height);
    border-bottom: 1px solid rgba(0, 0, 0, .08);
    background-color: var(--color-cream);
    overflow: auto;

    @media @q-md-min {
        height: 21svh;
        top: calc((21svh * -1) + var(--navbar-height) + 3.5rem);
        align-items: end;
        margin-bottom: 3rem;
    }
}

.scroll-navigation__link {
    .typography-link();
}
</style>
